export const VARIABLE_VALIDATION_REGEX = /^([a-zA-Z0-9\.]+)$/;
export class Validator {
    isValid(model) {
        try {
            this.validate(model);
            model.$invalid = false;
            model.$validationError = undefined;
            return true;
        }
        catch (e) {
            model.$invalid = true;
            model.$validationError = e;
            return false;
        }
    }
}
